import Commons from '../../../../Services/Common/Common';

/**
 * SER_BASIC 양식(템플릿) 스키마 — TB_SD_TEMPLATE_VERSION / TB_SD_TEMPLATE_ITEM
 */
export const SER_BASIC_FORM_Schema = {
  fields: {
    versionId: { initial: '', label: '버전ID' },
    versionNo: { initial: '', label: '버전번호' },
    versionNm: { initial: '', label: '버전명' },
    status: { initial: 'DRAFT', label: '상태' },
    totalScore: { initial: 800, label: '기준총점' },
    changeMemo: { initial: '', label: '변경메모' },
  },

  mapper: {
    /** 평가표 버전 목록 (GetSerBasicR2) */
    search1: {
      CustCd: (_, context) => Commons.EncryptAES(context.custCd || ''),
      UserId: (_, context) => context.userInfo?.userid,
    },

    /** 평가표 상세 (GetSerBasicR3) */
    search2: {
      CustCd: (_, context) => Commons.EncryptAES(context.custCd || ''),
      VersionId: (_, context) =>
        Commons.EncryptAES(
          String(context.versionId ?? context.formCode ?? '').trim()
        ),
      UserId: (_, context) => context.userInfo?.userid,
    },

    /** DRAFT 열기/생성 (SaveSerBasicU1) */
    openDraft: {
      CustCd: (_, context) => Commons.EncryptAES(context.custCd || ''),
      UserId: (_, context) => context.userInfo?.userid,
    },

    /** DRAFT 저장 (SaveSerBasicU2) */
    save1: {
      CustCd: (_, context) => Commons.EncryptAES(context.custCd || ''),
      VersionId: (row) =>
        Commons.EncryptAES(String(row.versionId ?? row.formCode ?? '')),
      VersionNm: (row) =>
        Commons.EncryptAES(row.versionNm || row.formName || ''),
      TotalScore: (row) =>
        Commons.EncryptAES(String(row.totalScore ?? 800)),
      ChangeMemo: (row) => Commons.EncryptAES(row.changeMemo || row.remark || ''),
      FormData: (row) =>
        Commons.EncryptAES(
          JSON.stringify(
            row.formData || {
              steps: row.steps,
              arrayList: row.arrayList,
              arrayList2: row.arrayList2,
              formName: row.formName,
            }
          )
        ),
      UserId: (_, context) => context.userInfo?.userid,
    },

    /** DRAFT 배포 (SaveSerBasicU3) */
    publish1: {
      CustCd: (_, context) => Commons.EncryptAES(context.custCd || ''),
      VersionId: (_, context) =>
        Commons.EncryptAES(String(context.versionId ?? '')),
      UserId: (_, context) => context.userInfo?.userid,
    },

    /** DRAFT 양식 삭제 (DeleteSerBasicD2) */
    delete1: {
      CustCd: (_, context) => Commons.EncryptAES(context.custCd || ''),
      VersionId: (row) =>
        Commons.EncryptAES(String(row.versionId ?? row.formCode ?? '')),
      UserId: (_, context) => context.userInfo?.userid,
    },
  },
};
